import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import RefundPolicy from './components/RefundPolicy';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';

const Legal = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-violet-950 via-slate-950 to-purple-950 text-white py-24 overflow-hidden">
        <div className="absolute inset-0 opacity-10"></div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Legal &amp; Policies
          </h1>
          <p className="text-lg md:text-xl text-violet-200 max-w-3xl mx-auto">
            Refund Policy, Terms of Service &amp; Privacy Policy — please read these carefully before using our IT services
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <a href="/legal#refund-policy" className="text-sm text-violet-300 hover:text-white border border-violet-500 hover:border-white px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer">Refund Policy</a>
            <a href="/legal#terms" className="text-sm text-violet-300 hover:text-white border border-violet-500 hover:border-white px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer">Terms &amp; Conditions</a>
            <a href="/legal#privacy" className="text-sm text-violet-300 hover:text-white border border-violet-500 hover:border-white px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer">Privacy Policy</a>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <RefundPolicy />
          <TermsConditions />
          <div className="mt-16">
            <PrivacyPolicy />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Legal;
